const VALHALLA_SERVER = import.meta.env.VITE_VALHALLA_SERVER;
const VALHALLA_USERNAME = import.meta.env.VITE_VALHALLA_USERNAME;
const VALHALLA_PASSWORD = import.meta.env.VITE_VALHALLA_PASSWORD;

const apiRouteRequest = async ({
    path,
    method = "GET",
    body
}) => {
    if (!VALHALLA_SERVER) {
        throw new Error("Route server not configured");
    }

    if (!VALHALLA_USERNAME || !VALHALLA_PASSWORD) {
        throw new Error("Route credentials not configured");
    }

    const credentials = btoa(`${VALHALLA_USERNAME}:${VALHALLA_PASSWORD}`);

    const response = await fetch(`${VALHALLA_SERVER}${path}`,
        {
            method,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Basic ${credentials}`,
            },
            body: body !== undefined ? JSON.stringify(body) : undefined
        }
    );

    if (!response.ok) {
        let message = `Valhalla request failed: ${response.status}`;

        try {
            const errorData = await response.json();

            message = errorData?.error || errorData?.message || message;
        } catch {
        }

        throw new Error(message);
    }

    return response.json();
}

export default apiRouteRequest;